import React, { useState, useEffect } from "react";
import InputField from "../../components/InputField";
import Dropdown from "../../components/Dropdown";
import { getAllServiceCategories } from "../../api/Agreement";
import { useAuth } from "../../providers/AuthContext";

const AgreementServiceForm = ({
  agreementService,
  setAgreementService,
  setHasChanges,
  disabledFields = [],
}) => {
  const { getAccessToken } = useAuth();
  const [categories, setCategories] = useState([]);

  const isDisabled = (fieldName) => disabledFields.includes(fieldName);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const accessToken = await getAccessToken();
        const data = await getAllServiceCategories(accessToken);
        setCategories(data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const selectedCategoryName = categories.find(
    c => c.agreementServiceCategoryPublicId === agreementService?.categoryPublicId
  )?.name || agreementService?.category || "";

  return (
    <>
      <div className="grid grid-cols-2 gap-6 w-full">
        <div className="flex flex-col gap-4">

          <InputField
            label="Agreement service ID"
            placeholder="Auto-assigned"
            value={agreementService?.agreementServicePublicId || ""}
            onChange={(e) => {
              setAgreementService((s) => ({ ...s, agreementServicePublicId: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("agreementServicePublicId")}
            />

          <InputField
            label="Name"
            placeholder="Name"
            value={agreementService?.name || ""}
            onChange={(e) => {
              setAgreementService((s) => ({ ...s, name: e.target?.value }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={isDisabled("name")}
            />

          <Dropdown
            label="Category"
            options={categories.map(c => c.name)}
            value={selectedCategoryName}
            selectedOptions={selectedCategoryName ? [selectedCategoryName] : []}
            onSelect={(name) => {
              const cat = categories.find(c => c.name === name);
              setAgreementService((s) => ({
                ...s,
                categoryPublicId: cat?.agreementServiceCategoryPublicId || null,
                category: name,
              }));
              setHasChanges(true);
            }}
            disabled={isDisabled("category")}
          />

          <InputField
            label="Website URL"
            placeholder="https://www.diflex.se/alla-tjanster/#..."
            value={agreementService?.websiteUrl || ""}
            onChange={(e) => {
              setAgreementService((s) => ({ ...s, websiteUrl: e.target?.value }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={isDisabled("websiteUrl")}
            />

        </div>

        <div className="flex flex-col gap-4">

          <InputField
            label="Comment"
            placeholder="Comment"
            value={agreementService?.comment || ""}
            onChange={(e) => {
              setAgreementService((s) => ({ ...s, comment: e.target?.value }));
              setHasChanges(true);
            }}
            className="w-full"
            disabled={isDisabled("comment")}
            />

          <InputField
            label="Active for agreement"
            placeholder="Active"
            value={agreementService?.isActiveForAgreement || ""}
            onChange={(e) => {
                setAgreementService((s) => ({ ...s, isActiveForAgreement: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={isDisabled("isActiveForAgreement")}
            />

        </div>
      </div>
    </>
  );
};

export default AgreementServiceForm;
